import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { ContainerWrapper, NavStrip, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import { searchObj, arrdata } from "./searchObj";


class PrinciplesSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      searchOutput: '',
      errorField: '',
    }
    this.onTermChange = this.onTermChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  componentDidMount() {
   window.scrollTo(0, 0);
    
  }
  onTermChange (e) {
    const searchTerm = e.target.value;
    this.setState(() => ({ searchTerm }));
  }
  
   getSearch(url) {
    return fetch(url)
    .then(response => response.text())
    .then(res => this.setState(() => ({ searchOutput: res ? res : '' })))
    .catch(error => {console.log(error)})
  }
  
  onSubmit(e) {
    e.preventDefault();
    if(!this.state.searchTerm) {
      this.setState(() => ({ errorField: "You must provide a search string" }));
      return;
    }
    else {      
      this.setState({ errorField: '' });
      const encodeuri = encodeURI(`http://72.142.123.40:3000/?queryTerm=${this.state.searchTerm}`);
      this.getSearch(encodeuri);
     }
  }
  render() {
    let cnt = 0;
    return (
     <div>
      <HelmetTitle title="Search" />
      <Layout
        head={
          <React.Fragment>
            <Navbar />
            <NavStrip />
          </React.Fragment>
        }
        body={
          <ContainerWrapper>
           <h3>Enter search term</h3>
           <p>{this.state.errorField}</p>
           <form onSubmit={this.onSubmit}>
            <input 
              type="text" 
              placeholder="search term" 
              value={this.state.searchTerm}
              onChange={this.onTermChange}
              autoFocus
              style={{width: "70%"}}
            />
            <textarea
              placeholder="watch for result here..."
              value={this.state.searchOutput}
              rows={10}
              style={{width: "90%"}}
             ></textarea>
            <button type="submit">Search</button>
           </form>
           <div>
             <table className="table">
              {
                arrdata &&
              <thead>
                <tr>
                  <th>Principle Title</th>
                  <th>Principle Name</th>
                  <th>Score</th>
                  <th>Articles</th>
                </tr>
              </thead>
              }
              <tbody>
                {arrdata.map(term => {
                    let ff2 = [];
                    const ff = JSON.stringify(term.articles);
                    ff2.push(JSON.parse(ff));
                      
                  return (
                  <tr key={cnt++}>
                    <td>{term.id}</td>
                    <td>{term['Topic.Theme']}</td>
                    <td>{term.topicNo}</td>
                    <td>{ console.log(ff2[0])
                      
                    }</td>
                  </tr>
                  )
                })}
              </tbody>
             </table>
           </div>
          </ContainerWrapper>
        }
      />
    </div>
    );
  }
}




export default withRouter(PrinciplesSearch)



// WEBPACK FOOTER //
// ./src/Pages/Principles/Search.js